<template>
  <span>{{ maskedPhone }}</span>
</template>

<script>
export default {
  props: {
    phone: {
      type: String,
      default: ''
    },
    visibleDigits: {
      type: Number,
      default: 3
    }
  },
  computed: {
  maskedPhone() {
        if (!this.phone) return '—';
        const phone = String(this.phone);
        if (this.visibleDigits === 0) return 'X'.repeat(phone.length);
        const visible = phone.slice(-this.visibleDigits);
        const masked = 'X'.repeat(phone.length - this.visibleDigits);
        return masked + visible;
  }
  }
}
</script>